// extracted by mini-css-extract-plugin
export default {"customer-organization-form__device-limit-inputs-container":"DeviceLimit_customer-organization-form__device-limit-inputs-container__Z8bYI"};